import { ComponentRef, Directive, TemplateRef, ViewContainerRef, effect, inject, input } from '@angular/core';
import { LoadingComponent } from './loading.component';
import { __ } from '@app/shared/functions/object.functions';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector -- structural directive used as *loading= throughout the codebase
  selector: '[loading]',
  standalone: true,
})
export class LoadingDirective {
  private templateRef = inject<TemplateRef<unknown>>(TemplateRef);
  private viewContainerRef = inject(ViewContainerRef);

  readonly loading = input(false);

  readonly loadingClass = input('');

  private wrapperContainer!: ComponentRef<LoadingComponent>;

  constructor() {
    effect(() => this.renderLoading(this.loading(), this.loadingClass()));
  }

  private renderLoading(isLoading: boolean, cssClass: string): void {
    if (__.IsNullOrUndefined(isLoading) && __.IsNullOrUndefined(cssClass)) {
      return;
    }

    if (__.IsNullOrUndefined(this.wrapperContainer)) {
      this.wrapperContainer = this.viewContainerRef.createComponent(LoadingComponent);
    }

    // Keep OnPush loading wrappers in sync with directive input updates.
    this.wrapperContainer.setInput('templateRef', this.templateRef);
    this.wrapperContainer.setInput('isLoading', isLoading);
    this.wrapperContainer.setInput('cssClass', cssClass);
    this.wrapperContainer.changeDetectorRef.detectChanges();
  }
}
